// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__1mIXA","clinicsSelect":"TableHeading_clinicsSelect__2GEvN"};